var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgResponseStyle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.69,
    viewBox: "0 0 18 17.69",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(-1986.5 -802.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_13",
    "data-name": "Union 13",
    d: "M10.338,13.374c-3.425,0-7.3-4.323-7.463-4.507A.429.429,0,0,1,3.2,8.153a.433.433,0,0,1,.213.057,1.721,1.721,0,0,0,.687.179,8.534,8.534,0,0,1-3.4-4.414A11.564,11.564,0,0,1,0,.43.428.428,0,0,1,.5.006a9.886,9.886,0,0,1,4.13,2.039,2.877,2.877,0,0,0-.212-.488.427.427,0,0,1,.03-.48A.439.439,0,0,1,4.9.926c1.86.52,3.466,2.295,4.447,3.622a.427.427,0,0,1,.153-.335.437.437,0,0,1,.5-.038c2.642,1.63,4.043,3.344,4.169,5.095a3.53,3.53,0,0,1-.324,1.743l-.048.1a10.025,10.025,0,0,0,1.614.569.429.429,0,0,1-.1.846.4.4,0,0,1-.1-.013,11.17,11.17,0,0,1-1.883-.67l-.1.117a3.079,3.079,0,0,1-.311.317,3.5,3.5,0,0,1-2.587,1.092ZM10.339,13.256ZM1.5,3.7A7.262,7.262,0,0,0,5.832,8.3a.429.429,0,0,1-.057.82,6.982,6.982,0,0,1-1.309.143c2.976,2.827,4.95,3.257,5.873,3.256a2.647,2.647,0,0,0,1.986-.845.277.277,0,0,1,.032-.03s.046-.04.116-.113l.058-.06a28.794,28.794,0,0,1-2.68-1.528,20.636,20.636,0,0,1-4.511-3.7A.429.429,0,1,1,6.005,5.7a19.791,19.791,0,0,0,4.308,3.522,27.7,27.7,0,0,0,2.71,1.536l.046-.1a2.675,2.675,0,0,0,.25-1.329A3.7,3.7,0,0,0,12.5,7.379a9.273,9.273,0,0,0-1.962-1.825,1.951,1.951,0,0,1-.03,1.118.428.428,0,0,1-.375.255h-.018A.428.428,0,0,1,9.735,6.7c-.019-.035-1.839-3.34-4.2-4.6a2.38,2.38,0,0,1,.023,1.034.429.429,0,0,1-.718.216A11.053,11.053,0,0,0,.892.974,11.314,11.314,0,0,0,1.5,3.7Z",
    transform: "translate(2002.456 802.353) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_66",
    "data-name": "Line 66",
    d: "M16.64-.28H-.64A.36.36,0,0,1-1-.64.36.36,0,0,1-.64-1H16.64A.36.36,0,0,1,17-.64.36.36,0,0,1,16.64-.28Z",
    transform: "translate(1987.5 820.318)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResponseStyle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ResponseStyle.94409534cf48c007bc0012a421967d01.svg";